import { render, staticRenderFns } from "./MMP_HotkeysInfo.vue?vue&type=template&id=01bee68e&scoped=true&"
import script from "./MMP_HotkeysInfo.vue?vue&type=script&lang=js&"
export * from "./MMP_HotkeysInfo.vue?vue&type=script&lang=js&"
import style0 from "./MMP_HotkeysInfo.vue?vue&type=style&index=0&id=01bee68e&prod&lang=css&"
import style1 from "./MMP_HotkeysInfo.vue?vue&type=style&index=1&id=01bee68e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bee68e",
  null
  
)

export default component.exports